const SpeechRecognition = 
	window.SpeechRecognition || window.webkitSpeechRecognition;


export default SpeechRecognition;
